import ResumeButton from "../ui/ResumeButton";

type SocialLink = {
  href: string;
  label: string;
};

type HeroSectionProps = {
  about: string;
  profileImage: string;
  socialLinks: SocialLink[];
};

const HeroSection = ({
  about,
  profileImage,
  socialLinks,
}: HeroSectionProps) => (
  <section className="hero" id="home" aria-labelledby="hero-title">
    <div className="hero__ambient" aria-hidden="true">
      <span className="hero__orbit hero__orbit--one" />
      <span className="hero__orbit hero__orbit--two" />
    </div>

    <div className="hero__topline" data-hero-enter>
      <span>Kajang, Malaysia</span>
      <span>Portfolio - 2K26</span>
    </div>

    <div className="hero__grid">
      <div className="hero__copy">
        <p className="eyebrow" data-hero-enter>
          Software developer · Full-stack + mobile
        </p>
        <h1 id="hero-title" aria-label="Zul Aiman, also known as Manza">
          <span className="hero__title-line" data-hero-line>
            <span>Zul Aiman</span>
          </span>
          <span
            className="hero__title-line hero__title-line--accent"
            data-hero-line
          >
            <span>Manza.</span>
          </span>
        </h1>
        <p className="hero__intro" data-hero-enter>
          {about}
        </p>

        <div className="hero__actions" data-hero-enter>
          <a className="button-link" href="#projects" data-cursor="View">
            View selected work
            <span aria-hidden="true">↘</span>
          </a>
          <ResumeButton />
        </div>

        <div className="hero__socials" data-hero-enter>
          {socialLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target={link.href.startsWith("http") ? "_blank" : undefined}
              rel={link.href.startsWith("http") ? "noreferrer" : undefined}
              aria-label={link.label}
              data-cursor="Open"
            >
              {link.label}
              <span aria-hidden="true">↗</span>
            </a>
          ))}
        </div>
      </div>

      <div className="hero__portrait" data-hero-enter>
        <div className="hero__portrait-frame">
          <img
            src={profileImage}
            alt="Zul Aiman, software developer"
            width="820"
            height="1080"
            fetchPriority="high"
          />
          <div className="hero__portrait-label" aria-hidden="true">
            <span>MANZA / 01</span>
            <span>Available for selected collaborations</span>
          </div>
        </div>
      </div>
    </div>

    <a
      className="hero__scroll"
      href="#about"
      aria-label="Scroll to about section"
    >
      <span>Scroll to explore</span>
      <span aria-hidden="true">↓</span>
    </a>
  </section>
);

export default HeroSection;
